export default {
    COMMISSION_RULES_UPDATE_REQUEST: 'APP/COMMISSION_MANAGEMENT_RULES_UPDATE/COMMISSION_RULES_UPDATE_REQUEST',
    COMMISSION_RULES_UPDATE_SUCCESS: 'APP/COMMISSION_MANAGEMENT_RULES_UPDATE/COMMISSION_RULES_UPDATE_SUCCESS',
    COMMISSION_RULES_UPDATE_ERROR: 'APP/COMMISSION_MANAGEMENT_RULES_UPDATE/COMMISSION_RULES_UPDATE_ERROR',
  };